export default __webpack_public_path__ + "static/hero-light-1b675ce28a359071445b829636239770.svg";